import {
  Box,
  Button,
  OutlinedInput,
  InputAdornment,
  Divider,
  IconButton,
  Tooltip,
  useMediaQuery,
} from '@mui/material';
import { useFilters } from './hooks/useFilters.tsx';
import { Search, Download, FilterAlt } from '@mui/icons-material';
import { Select, TOOLBAR_FIELD_GAP, toolbarFieldSx } from '@ui';
import { t } from 'i18next';
import { theme } from '@store';

export const Filters = () => {
  const {
    filters,
    groupByOptions,
    handleGroupByChange,
    handleSearchChange,
    handleToggleFiltersCard,
    handleDownloadReportCSV,
    isFileDownloading,
    isItemsView,
    showDownloadButton,
    searchPlaceholder,
    searchQuery,
    isFiltersCardOpen,
  } = useFilters();

  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box
      sx={{
        width: '100%',
        padding: '1rem',
        display: 'flex',
        justifyContent: 'space-between',
        bgcolor: 'white',
        border: theme => `1px solid ${theme.palette.grey[300]}`,
        borderBottom: 'none',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: TOOLBAR_FIELD_GAP,
        }}
      >
        <OutlinedInput
          id='searchField'
          placeholder={`Search ${searchPlaceholder}`}
          value={searchQuery}
          onChange={handleSearchChange}
          sx={toolbarFieldSx}
          startAdornment={
            <InputAdornment sx={{ padding: 0 }} position='start'>
              <Search />
            </InputAdornment>
          }
        />

        {isItemsView && (
          <Select
            sx={{
              ...toolbarFieldSx,
              display: 'flex',
              justifyContent: 'center',
            }}
            size='medium'
            name='groupBy'
            label='Group by'
            value={filters.group_by}
            onChange={handleGroupByChange}
            options={groupByOptions}
            clearable
            clearLabel='All'
          />
        )}
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Button
            sx={{
              fontWeight: 'regular',
              fontSize: '1rem',
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              ...(isFiltersCardOpen && {
                bgcolor: theme.palette.selectedTableRowBg.main,
              }),
            }}
            variant='text'
            onClick={handleToggleFiltersCard}
          >
            <FilterAlt />
            {!isSmallScreen && !isFiltersCardOpen && 'FILTERS'}
            {filters.options?.$and?.length && filters.options.$and.length > 0
              ? `(${filters.options.$and.length})`
              : ''}
          </Button>
        </Box>

        {showDownloadButton && (
          <>
            <Divider
              sx={{
                width: '1px',
                height: '100%',
                ml: 2,
                mr: 0.5,
                bgcolor: theme => theme.palette.grey[300],
              }}
            />
            <Tooltip title={t('reporting.report.preview.requestToDownload')}>
              <IconButton
                onClick={handleDownloadReportCSV}
                sx={{
                  height: 40,
                  width: 40,
                  display: 'grid',
                  placeItems: 'center',
                }}
                disabled={isFileDownloading}
              >
                <Download color='primary' />
              </IconButton>
            </Tooltip>
          </>
        )}
      </Box>
    </Box>
  );
};
